import { render, staticRenderFns } from "./ProbabilityBar.vue?vue&type=template&id=4afa53ef&scoped=true&"
import script from "./ProbabilityBar.vue?vue&type=script&lang=ts&"
export * from "./ProbabilityBar.vue?vue&type=script&lang=ts&"
import style0 from "./ProbabilityBar.vue?vue&type=style&index=0&id=4afa53ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afa53ef",
  null
  
)

export default component.exports